import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Props, Playground } from 'docz';
import MaskInput from './src/MaskInput.tsx';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h3 {...{
      "id": "maskinput"
    }}>{`MaskInput`}</h3>
    <Props of={MaskInput} mdxType="Props" />
    <h2 {...{
      "id": "with-no-mask-it-works-like-a-simple-input"
    }}>{`With no mask, it works like a simple input`}</h2>
    <Playground __position={1} __code={'<MaskInput type=\"text\" />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      MaskInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <MaskInput type="text" mdxType="MaskInput" />
    </Playground>
    <h2 {...{
      "id": "basic-usage-mercosul-car-plate"
    }}>{`Basic Usage (mercosul car plate)`}</h2>
    <Playground __position={2} __code={'<MaskInput type=\"text\" mask=\"AAA-99A9\" />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      MaskInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <MaskInput type="text" mask="AAA-99A9" mdxType="MaskInput" />
    </Playground>
    <h2 {...{
      "id": "phone-number"
    }}>{`Phone number`}</h2>
    <Playground __position={3} __code={'<MaskInput type=\"text\" mask=\"(99) 9999-9999\" />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      MaskInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <MaskInput type="text" mask="(99) 9999-9999" mdxType="MaskInput" />
    </Playground>
    <h2 {...{
      "id": "multiple-maks"
    }}>{`Multiple Maks`}</h2>
    <Playground __position={4} __code={'<MaskInput\n  type=\"text\"\n  mask={[\'(99) 9999-9999\', \'(99) 9 9999-9999\']}\n  placeholder=\"Phone number\"\n/>'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      MaskInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <MaskInput type="text" mask={['(99) 9999-9999', '(99) 9 9999-9999']} placeholder="Phone number" mdxType="MaskInput" />
    </Playground>
    <h2 {...{
      "id": "brazilian-documents-cpf--cnpj"
    }}>{`Brazilian documents (CPF / CNPJ)`}</h2>
    <Playground __position={5} __code={'<MaskInput\n  type=\"text\"\n  name=\"document\"\n  mask={[\'999.999.999-99\', \'99.999.999/9999-99\']}\n  placeholder=\"Type the CPF or CNPJ\"\n/>'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      MaskInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <MaskInput type="text" name="document" mask={['999.999.999-99', '99.999.999/9999-99']} placeholder="Type the CPF or CNPJ" mdxType="MaskInput" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      